// File: src/pages/BlogDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "../assets/css/BlogDetail.css"; // new css file
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [allBlogs, setAllBlogs] = useState([]); // to derive categories & full list
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    if (id) {
      fetchBlog();
      fetchRecentBlogs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchBlog = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs/${id}`);
      setBlog(response.data);
    } catch (error) {
      console.error("Error fetching blog:", error);
    }
  };

  const fetchRecentBlogs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs`);
      // keep full list
      setAllBlogs(response.data || []);
      // remove current blog from recent list and slice the first 8 (or more)
      const filtered = (response.data || []).filter((item) => item._id !== id);
      setRecentBlogs(filtered.slice(0, 8));
    } catch (error) {
      console.error("Error fetching recent blogs:", error);
    }
  };

  // Derived categories
  const categories = ["All", ...Array.from(new Set(allBlogs.map((b) => b.category).filter(Boolean)))];

  // Apply selectedCategory filter to recentBlogs (client-side)
  const displayedRecent = selectedCategory === "All"
    ? recentBlogs
    : recentBlogs.filter((r) => r.category === selectedCategory);

  if (!blog) {
    return <p className="bd-loading">Loading blog details...</p>;
  }

  return (

    <>

      <BreadcrumbSection
        title="Blog Details"
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Blogs", to: "/blogs" },

        ]}
        backgroundImage={BredcrumpImage}
      />
      <div className="bd-page">
        {/* <h2 className="bd-page-title">Blog Details</h2> */}

        <div className="bd-container">
          {/* Main Column */}
          <main className="bd-main">
            <div className="bd-feature">
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${blog.image}`}
                alt={blog.title}
                className="bd-feature-img"
              />
            </div>

            <h1 className="bd-title">{blog.title}</h1>

            <p className="bd-meta">
              <span>by {blog.author || "admin"}</span>
              <span className="bd-sep">|</span>
              <span>{new Date(blog.createdAt).toLocaleDateString("en-IN", {
                year: "numeric",
                month: "short",
                day: "numeric"
              })}</span>
              <span className="bd-sep">|</span>
              <span className="bd-cat">{blog.category || "Uncategorized"}</span>
            </p>

            <div className="bd-content">
              {/* blog.content may contain HTML if you store HTML in DB. 
                If it is HTML you should render with dangerouslySetInnerHTML */}
              {typeof (blog.content || blog.description) === "string" ? (
                // If content is HTML and safe, use dangerouslySetInnerHTML:
                <div
                  dangerouslySetInnerHTML={{ __html: blog.content || blog.description }}
                />
              ) : (
                <div>{blog.content || blog.description}</div>
              )}
            </div>
          </main>

          {/* Sidebar */}
          <aside className="bd-sidebar">
            <div className="bd-sidebar-card">
              <h3 className="sidebar-title">Recent Posts</h3>

              <div className="sidebar-filter">
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  aria-label="Filter recent posts by category"
                >
                  {categories.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>

              <div className="recent-list">
                {displayedRecent.map((recent) => (
                  <Link
                    to={`/blog/${recent._id}`}
                    key={recent._id}
                    className="recent-item"
                  >
                    <div className="recent-thumb">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/uploads/${recent.image}`}
                        alt={recent.title}
                      />
                    </div>
                    <div className="recent-info">
                      <h4 className="recent-title">{recent.title}</h4>
                      <div className="recent-meta">
                        <span className="recent-date">
                          {new Date(recent.createdAt).toLocaleDateString("en-IN", {
                            year: "numeric", month: "short", day: "numeric"
                          })}
                        </span>
                        <span className="recent-cat">{recent.category}</span>
                      </div>
                    </div>
                  </Link>
                ))}

                {displayedRecent.length === 0 && (
                  <p className="no-results">No posts found in this category.</p>
                )}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </>


  );
};

export default BlogDetail;
